module.exports = __webpack_public_path__ + "static/media/zoom.e84c8c16.svg";